import { Card, Flex, Separator, Skeleton } from "@radix-ui/themes";
import { Member } from "../../api/member/Member.model";
import { MemberItem } from "./MemberItem";

export function MemberItemSkeleton() {
  return (
    <Flex height={"40px"} align={"center"} gap={"3"}>
      <Skeleton width={"32px"} height={"32px"} />

      <Skeleton height={"20px"} width={"200px"} />
    </Flex>
  );
}

function MembersListLoader() {
  return (
    <Flex
      p={"4"}
      direction={"column"}
      style={{ boxShadow: "var(--shadow-4)", borderRadius: "12px" }}
    >
      <MemberItemSkeleton />
      <Separator my="3" size="4" />
      <MemberItemSkeleton />
      <Separator my="3" size="4" />
      <MemberItemSkeleton />
    </Flex>
  );
}

export const MembersList = ({
  members,
  refetch,
  isAdmin,
  isLoading,
}: {
  members: Member[];
  refetch: () => void;
  isAdmin: boolean;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <MembersListLoader />;
  }

  if (!members || members.length === 0 || (members as any).code) {
    return null;
  }

  return (
    <Flex
      p={"4"}
      direction={"column"}
      style={{ boxShadow: "var(--shadow-4)", borderRadius: "12px" }}
    >
      {members?.map((item, index) => (
        <>
          <MemberItem
            key={index}
            index={index}
            member={item}
            refetch={refetch}
            isAdmin={isAdmin}
          />

          {index != members.length - 1 && <Separator my="3" size="4" />}
        </>
      ))}
    </Flex>
  );
};
